var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00244141 1.884L6.99982 5.88201L13.9972 1.884C13.9713 1.37445 13.7759 0.895489 13.451 0.545228C13.1262 0.194966 12.6964 -9.35848e-05 12.2498 3.36835e-08H1.74982C1.3032 -9.35848e-05 0.873458 0.194966 0.548597 0.545228C0.223736 0.895489 0.028345 1.37445 0.00244141 1.884Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.11804L7 8.11805L0 4.11804V10.0001C0 10.5305 0.184374 11.0392 0.512563 11.4143C0.840752 11.7893 1.28587 12.0001 1.75 12.0001H12.25C12.7141 12.0001 13.1592 11.7893 13.4874 11.4143C13.8156 11.0392 14 10.5305 14 10.0001V4.11804Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8b3ac539533f481b1e063db1b0b29249.svg";
export { ForwardRef as ReactComponent };